var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whitespace-no-wrap ds-text-2xs"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('i',{staticClass:"ml-1 ds-text-2xs",class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }